

<div class="row">
  <div class="col-md-4 order-md-first order-xl-first">
    <span>Copyright © Universal Health 2018</span> <br />
    <a href="https://www.universalhealth.com.au/privacy/" class="footer-link">Privacy Statement</a> |
    <a href="https://www.universalhealth.com.au/disclaimer/" class="footer-link"> Disclaimer</a>
  </div>

  <div class="col-md-4 text-center order-first">
    <a href="https://www.universalhealth.com.au/">
      <img src="https://www.universalhealth.com.au/wp-content/themes/unihealth/images/logo.png">
    </a>
  </div>

  <div class="col-md-4 order-last">
    <span>Level 4</span><br />
    <span>377 New South Head Road</span><br />
    <span>Double Bay NSW 2028</span><br />
    <span>Australia</span><br />
    <span>Tel: <a href="tel:+612 9302 2888">+612 9302 2888</a></span>
  </div>

</div>